import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type HideMarketShopInventoryItemRequest = {
  id: number
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const hideMarketShopInventoryItem = async (
  data: HideMarketShopInventoryItemRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'hide',
    buildingId: data.buildingId,
    ids: [data.id],
  })
  return response.data
}

export const useHideMarketShopInventoryItem = () => {
  return useMutation({
    mutationFn: hideMarketShopInventoryItem,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      if (affected > 0) {
        toastFactory.success('Item hidden successfully')
      } else {
        toastFactory.error('Failed to hide item')
      }
    },
  })
}
